module.exports = __webpack_public_path__ + "static/media/map-pin-location.3edfc917.svg";